/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DictionaryItem, getRouteInitData } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { map$, switchMap$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import { getLeadBoardItemId, LeadBoardListItem, VirtualPosition } from '../../..';
import { LeadBoardCommandService } from '../lead-board-command.service';
import { LeadBoardFormState } from '../lead-board-form.service';

@Component({
  standalone: false,
  selector: 'gh-lead-board-mobile-container',
  templateUrl: 'lead-board-mobile-container.component.html',
  styleUrls: ['lead-board-mobile-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadBoardMobileContainerComponent implements OnInit {
  prioritiesDict: DictionaryItem<any>[];
  stagesDict: DictionaryItem<any>[];

  cards$: Observable<LeadBoardListItem[]>;
  cardCount$: Observable<number>;
  cardCountLabel$: Observable<string>;

  @ViewChild('bodyViewport', { read: ElementRef, static: false }) bodyViewport: ElementRef;

  constructor(private route: ActivatedRoute,
              public form: LeadBoardFormState,
              private commandService: LeadBoardCommandService) {
  }

  ngOnInit(): void {
    const { priorities, stages } = getRouteInitData(this.route);

    this.prioritiesDict = priorities;
    this.stagesDict = stages;

    this.cards$ = this.form.mobileFilter$.pipe(
      switchMap$(({ priority, stage }) => this.form.cardsFor$(priority, stage)));
    this.cardCount$ = this.cards$.pipe(map$((cards) => cards.length));
    this.cardCountLabel$ = this.cardCount$.pipe(map$((count) => count === 1 ? 'lbl_card' : 'lbl_cards'));
  }

  onPriorityChange(priority: number): void {
    this.commandService.setMobilePriority(priority);
  }

  onStageChange(stage: number): void {
    this.commandService.setMobileStage(stage);
  }

  onScroll(position: VirtualPosition): void {
    this.commandService.setMobileScrollPosition(position);
  }

  getCardId(index: number, item: LeadBoardListItem): ID {
    return getLeadBoardItemId(item);
  }
}
